// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".openlayers-wrapper[data-v-5062a15f] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
